/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-explicit-any */

export default (nif: any) => {
  nif = nif.replace(/[^\d]/g, '')
  nif = nif.substring(0, 9)

  return nif
}
